import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {Text} from 'wix-ui-tpa/cssVars'
import {CloseButton} from '../close-button'
import {classes} from './header.st.css'
import {HeaderProps} from './interfaces'

export const Header = ({
  title,
  subtitle,
  closeButtonAsButton,
  className,
  titleClassName,
  closeModal,
  alignment = 'center',
  weight = 'bold',
}: HeaderProps) => {
  const {t} = useTranslation()

  const alignCenter = alignment === 'center'
  const boldWeight = weight === 'bold'

  return (
    <div
      className={classNames(classes.header, className, {
        [classes.alignCenter]: alignCenter,
        [classes.alignStart]: !alignCenter,
      })}
    >
      {title ? (
        <Text
          id={t('seatings_mobile_modal_eventName_aria')}
          tagName="h1"
          className={classNames(boldWeight ? classes.title : classes.lightTitle, classes.titlePadding, titleClassName)}
        >
          {title}
        </Text>
      ) : null}
      {subtitle ? (
        <Text tagName="p" className={classes.subtitle}>
          {subtitle}
        </Text>
      ) : null}
      {closeModal ? (
        <CloseButton
          className={classes.closeButton}
          closeButtonAsButton={closeButtonAsButton}
          closeModal={closeModal}
        />
      ) : null}
    </div>
  )
}
